import { render, staticRenderFns } from "./_Sub_header.vue?vue&type=template&id=b98fec5a&scoped=true&"
import script from "./_Sub_header.vue?vue&type=script&lang=js&"
export * from "./_Sub_header.vue?vue&type=script&lang=js&"
import style0 from "./_Sub_header.vue?vue&type=style&index=0&id=b98fec5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98fec5a",
  null
  
)

export default component.exports